import { useState } from "react";
import { useDebouncedEffect } from "../../../../packages/hooks";
import { useControlContext } from "../../../control";
import { useAppDispatch } from "../../../../hooks";
import { postEventMessageReading, readMessage } from "../../actions";

type State = Array<string>;

export const useMessageReading = () => {
  const dispatch = useAppDispatch();
  const { api } = useControlContext();
  const [newReadMessages, setReadMessages] = useState<State>([]);
  const { postEventApi } = api;
  const messageAmount = newReadMessages.length;

  useDebouncedEffect({
    effect: () => {
      if (messageAmount) {
        const [lastReadMessageId] = newReadMessages.sort(
          (a, b) => Number(b) - Number(a)
        );

        const params = { postEventApi, lastReadMessageId };

        dispatch(postEventMessageReading(params));
        setReadMessages([]);
      }
    },
    deps: [messageAmount],
    delay: 1000,
  });

  const handleReadMessage = (messageId: string) => () => {
    dispatch(readMessage(messageId));

    setReadMessages((prevMessages) =>
      prevMessages.includes(messageId)
        ? prevMessages
        : [...prevMessages, messageId]
    );
  };

  return { handleReadMessage };
};
